// extracted by mini-css-extract-plugin
module.exports = {"root":"InsightsFilters_root__3vh_J","reverse":"InsightsFilters_reverse__1yLr9"};